{
  "dayLengthMs": 1440000,
  "hourOffset": 9
}
